import { render, staticRenderFns } from "./Novo.vue?vue&type=template&id=a180dd9c&lang=pug&"
import script from "./Novo.vue?vue&type=script&lang=js&"
export * from "./Novo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports